<template>
    <div class="nav-bar-box">
        <div class="nav-bar-menu">
            <nav-item v-for="route in addRouters" :key="route.id" :item="route" base-path=""></nav-item>
        </div>
        <!-- <el-dropdown size="small">
           <div class="user-show-box">
             <div style="margin-right: 10px"><svg-icon icon-class="user"></svg-icon></div>
             <div>{{ name }}</div>
           </div>
           <el-dropdown-menu class="user-dropdown" slot="dropdown">
             <router-link class="inlineBlock" to="/">
               <el-dropdown-item>
                 首页
               </el-dropdown-item>
             </router-link>
             <el-dropdown-item divided>
               <span @click="logout" style="display:block;">登出</span>
             </el-dropdown-item>
           </el-dropdown-menu>
         </el-dropdown>-->
        <div style="display: flex;width: 17rem;flex-direction: row;">
            <div style="width: 17%" v-if="userType == '0' && warningMenu">

                <a href="javascript:void(0)"  @click="open()" v-if="warning"><el-badge :value="warningNum" class="item" :max="99"><img src="../../../../icons/svg/notice.gif" style="width: 1.2rem; height:1.2rem; " v-if="warning"
                /></el-badge></a>
                <a href="javascript:void(0)" @click="open()" v-if="!warning"><el-badge :value="warningNum" class="item" :max="99"><img src="../../../../icons/svg/notice.png" style="width: 1.2rem; height:1.2rem; " v-if="!warning"
                /></el-badge></a>

            </div>

            <div style="width: 17%">
                <a href="javascript:void(0)" @click="configOpen" v-if="configed"><el-badge :value="configNum" class="item" :max="99"><img src="../../../../icons/svg/message.gif" style="width: 1.2rem; height:1.2rem; "/></el-badge></a>
                <a href="javascript:void(0)" @click="configOpen" v-if="!configed"><el-badge :value="configNum" class="item" :max="99"><img src="../../../../icons/svg/message.png" style="width: 1.2rem; height:1.2rem; "/></el-badge></a>
            </div>
            <el-popover trigger="hover">
                <div class="userInfo-box" align="center">
                    <table>
                        <tr>
                            <td>用户账号：</td>
                            <td>{{customerInfo.name}}</td>
                        </tr>
                        <tr>
                            <td>用户姓名：</td>
                            <td>{{customerInfo.realName}}</td>
                        </tr>
                        <tr>
                            <td align="right">手机：</td>
                            <td>{{customerInfo.mobile}}</td>
                        </tr>
                        <tr>
                            <td>电子邮箱：</td>
                            <td>{{customerInfo.email}}</td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center">
                                <el-button size="small" @click="updateCustomer" style="width: 70%;color: #009bac;border-color:#009bac;">修改信息</el-button>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center">
                                <el-button size="small" @click="updateCustomerPwd" style="width: 70%;color: white;border-color:#009bac;background:#009bac">修改密码</el-button>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center">
                                <el-button size="small" @click="logout" style="width: 70%;color: red;border-color:red;">退出登录</el-button>
                            </td>
                        </tr>
                    </table>

                </div>

                <el-button class="but" slot="reference">
                    <div style="width: 33%;padding-right: 1.5rem">
                        <svg-icon icon-class="user" class="icon"></svg-icon>
                        {{ name }}
                    </div>
                </el-button>
            </el-popover>
            <div style="width: 33%; padding-right: 0rem;" v-if="userType == '0' && warningMenu">
                <a href="/static/preview/帮助手册.html" target="_blank" style="font-size: 0.8rem">帮助手册</a><br />
            </div>
        </div>
        <el-dialog
                class="updateUser"
                :visible.sync="userInfoVisible"
                width="30rem"
                title="修改信息"
                @close="closeForm('customerInfo')"
        >

            <div style="display: flex;align-items: center;margin-top: 20px;margin-left: 2rem">
                <el-form :label-position="labelPosition" label-width="80px" :model="customerInfo" :rules="rules"
                         ref="customerInfo">
                    <el-form-item label="用户账号" prop="name">
                        <el-input v-model="customerInfo.name" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="用户姓名" prop="realName">
                        <el-input v-model="customerInfo.realName"></el-input>
                    </el-form-item>
                    <el-form-item label="    手机" prop="mobile">
                        <el-input v-model="customerInfo.mobile"></el-input>
                    </el-form-item>
                    <el-form-item label="电子邮箱" prop="email">
                        <el-input v-model="customerInfo.email"></el-input>
                    </el-form-item>
                </el-form>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="closeForm('customerInfo')" size="small">取 消</el-button>
                <el-button type="primary" @click="saveCustomerInfo(customerInfo)" size="small">保存</el-button>
           </span>
        </el-dialog>
        <el-dialog
                class="updateUser"
                :visible.sync="pwdVisible"
                width="30rem"
                title="修改密码"
                @close="closeForm2('updatePwd')"
        >
            <!--<div class="div-hr"></div>-->
            <div style="display: flex; margin-top: 20px;margin-left: 2rem">
                <el-form :label-position="labelPosition" label-width="100px" :model="updatePwd" status-icon :rules="rules2"
                         ref="updatePwd" class="demo-ruleForm">
                    <el-form-item label="输入旧密码" prop="oldPassword">
                        <el-input type="password" v-model="updatePwd.oldPassword"></el-input>
                    </el-form-item>
                    <el-form-item label="输入新密码" prop="newPassword">
                        <el-input type="password" v-model="updatePwd.newPassword"></el-input>
                    </el-form-item>
                    <el-form-item label="确认新密码" prop="checkNewPassword">
                        <el-input type="password" v-model="updatePwd.checkNewPassword"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <!--<div class="div-hr" style="margin-bottom: 5px"></div>-->
            <span slot="footer" class="dialog-footer">
            <el-button @click="closeForm2('updatePwd')" size="small">取 消</el-button>
            <el-button type="primary" @click="saveCustomerPwd" size="small">保存</el-button>
        </span>
        </el-dialog>

        <el-dialog title="实时报警记录" :visible.sync="dialogTableVisible" width="65%" @close="onclose" class="warning">
            <!--:header-cell-style="{background: '#dfe9ee', color: '#222222'}"-->
            <el-table :data="tableData"
                      ref="warningTable"
                      height="55vh"
                      width="100%"
                      v-loading="buttonLoading"
                      size="mini"
                      @sort-change="sortChange"
                      :default-sort = "{prop: 'warningTime', order: 'descending'}"
                      @filter-change="handleFilterChange"
                      :row-class-name="tableRowClassName"
            >
                <el-table-column
                        label="序号"
                        align="center"
                        width="50%">
                    <template slot-scope="scope">
                        <span>{{scope.$index+(currentPage - 1) * pageSize + 1}} </span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="warningTime"
                        label="报警时间"
                        sortable="custom"
                        :formatter="tableTimeFormat"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="customerUserName"
                        label="用户名称"
                        :formatter="tableStringFormat"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="customerUserCode"
                        label="用户编号"
                        :formatter="tableStringFormat"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="meterName"
                        label="仪表名称"
                        :formatter="tableStringFormat"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="meterCode"
                        label="仪表编号"
                        :formatter="tableStringFormat"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="meterNum"
                        label="仪表表号"
                        :formatter="tableStringFormat"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="warningTypeId"
                        label="报警类型"
                        column-key="channel"
                        :filters="channelFilter"
                        :formatter="warningTypeFormat"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="warningStatus"
                        label="报警状态"
                        column-key="type"
                        :filters="typeFilter"
                        :formatter="tableStatusFormat"
                        align="center">
                </el-table-column>


                <el-table-column label="操作" width="90" align="center">

                    <template slot-scope="scope">
                        <el-button type="primary" style="padding: 7px 16px; background-color: #00a5b2"
                                   @click="rowClick(scope.row)">
                            确认
                        </el-button>

                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer" style="align-items: center;display: flex; flex-direction: row;width: 100%">


                <el-pagination

                        background
                        layout="total,prev, pager, next"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[20, 50, 100, 200, 500]"
                        :page-size="pageSize"
                        :total="pageTotal"
                        style="height: 10%;margin-top: 10px;width: 100%;text-align: center">
                </el-pagination>


                <el-button @click="redirect()" style="padding: 7px 16px; background-color: #f4f8f9;margin-top: 11px;">
                    查看历史
                </el-button>


                <el-button type="primary" @click="allConfirm()" :disabled="tableData.length === 0"
                           style="padding: 7px 16px; background-color: #00a5b2; margin-top: 11px;">
                    全部确认
                </el-button>

            </div>
        </el-dialog>
        <el-dialog title="批量配置记录" :visible.sync="configDialogVisible" width="75%" @close="configClose" :close-on-click-modal=false>
            <!--:header-cell-style="{background: '#dfe9ee', color: '#222222'}"-->
            <el-table :data="configData"
                      ref="configTable"
                      height="55vh"
                      width="100%"
                      v-loading="configLoading"
                      @filter-change="configHandleFilterChange"
                      :row-class-name="configTableClassName"
                      @select="selectOne"
                      @select-all="selectAll"
                      size="mini">
                <el-table-column type="selection" :selectable="checkSelectable"></el-table-column>
                <el-table-column
                        label="序号"
                        align="center"
                        width="50%">
                    <template slot-scope="scope">
                        <span>{{scope.$index+(configCurrentPage - 1) * configPageSize + 1}} </span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="meterCode"
                        label="仪表编码"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="customerUserName"
                        label="用户名称"
                        :formatter="tableStringFormat"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="settingTime"
                        label="配置时间"
                        :formatter="tableTimeFormat"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="settingTypeText"
                        label="配置类型"
                        column-key="settingType"
                        :filters="[{ text: '计费价格', value: '0100' }, { text: '报警金额', value: '0010' }, { text: '使能跳闸', value: '1000' }, { text: '囤积金额、透支金额', value: '0001' }]"
                        :formatter="tableStringFormat"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="operatorCode"
                        label="操作人"
                        :formatter="tableStringFormat"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="result"
                        label="配置结果"
                        column-key="result"
                        :formatter="configTableStatusFormat"
                        :filters="[{ text: '成功', value: true }, { text: '失败', value: false }]"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="updateTime"
                        label="更新时间"
                        :formatter="tableTimeFormat"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="value1"
                        label="配置值1"
                        :formatter="tableDataFormat"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="value2"
                        label="配置值2"
                        :formatter="tableStringFormat"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="version"
                        label="版本"
                        :formatter="tableStringFormat"
                        align="center">
                </el-table-column>


                <!--<el-table-column label="操作" width="90" align="center" >

                    <template slot-scope="scope">
                        <el-button :type="scope.row.flag ? 'info' : 'primary'" style="padding: 7px 10px;"
                                   @click="reSendCmd" :disabled="scope.row.flag ? true : false">
                            重新下发
                        </el-button>

                    </template>
                </el-table-column>-->
            </el-table>
            <div slot="footer" class="dialog-footer" style="align-items: center;display: flex; flex-direction: row;width: 100%">


                <el-pagination

                        background
                        layout="total, sizes, prev, pager, next"
                        @current-change="configHandleCurrentChange"
                        @size-change="configHandleSizeChange"
                        :current-page="configCurrentPage"
                        :page-sizes="[20, 50, 100, 200, 500]"
                        :page-size="configPageSize"
                        :total="configPageTotal"
                        style="height: 10%;margin-top: 10px;width: 100%;text-align: center">
                </el-pagination>


                <el-tooltip class="item" effect="dark" content="重新下发勾选的失败记录" placement="bottom">
                    <el-button @click="reSendCmd" style="padding: 7px 16px; background-color: #f4f8f9;margin-top: 11px;">
                        重新下发
                    </el-button>
                </el-tooltip>
                <el-button @click="seeMore" style="padding: 7px 16px; background-color: #f4f8f9;margin-top: 11px;">
                    查看更多
                </el-button>

            </div>
        </el-dialog>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import NavItem from './NavItem'
  import {identifierRegex, mobileRegex, emailRegex} from '@/utils/validate'
  import {Message} from 'element-ui'
  import { WS } from '@/utils/ws'
  import moment from 'moment'
  import Flex from "../../../../components/Flex"
  //import {selectWarningRecord} from "../../../../api/WarningRecord";
  //import { selectConfigRecord } from "../../../../api/WarningRecord";

  export default {
    name: 'NavBar',
    data() {

      let CheckCustomerByIdAndPwd = (rules, value, callback) => {
        if (value === '') {
          callback(new Error('请输入旧密码'));
        }
        const id = this.userId
        this.$store.dispatch('CheckCustomerByIdAndPwd', {rules, value, callback, id})//这儿的checkAge是写在store中的，vuex规定参数必须传对象。
      }
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入新密码'));
        } else {
          //获得用户的类型
          let userType = this.customerInfo.userType
          if (userType == 0) {
            if (!/^(?=.*\d)(?=.*[a-zA-Z]).+$/.test(value)) {
              callback(new Error('必须包含字母和数字'));
            }
          }
          if (this.updatePwd.checkNewPassword !== '') {
            this.$refs.updatePwd.validateField('checkNewPassword');
          }
          callback();
        }
      };
      let checvalidatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入新密码'));
        } else if (value !== this.updatePwd.newPassword) {


          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        check: '',//输入的密码与用户密码一致标识
        labelPosition: 'right',
        customerInfo: {
          id: "",
          name: '',
          realName: '',
          mobile: '',
          email: '',
          password: '',
          userType: ''
        },
        updatePwd: {
          oldPassword: '',
          newPassword: '',
          checkNewPassword: '',
        },

        //修改用户户信息
        userInfoVisible: false,
        rules: {
          name: [{required: true, pattern: identifierRegex, message: '请输入正确的用户账号', trigger: 'blur'}, {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }],
          realName: [{required: true, message: '用户姓名必填', trigger: 'blur',}, {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }],
          mobile: [{required: true, pattern: mobileRegex, message: '请输入正确的手机号', trigger: 'blur'}, {
            min: 11,
            max: 11,
            message: '长度为 11 个字符',
            trigger: 'blur'
          }],
          email: [{required: true, message: '请输入邮箱地址', trigger: 'blur'},
            {required: true, pattern: emailRegex, message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}, {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }],
        },
        //修改用戶密碼
        pwdVisible: false,
        rules2: {
          oldPassword: [
            {required: true, validator: CheckCustomerByIdAndPwd, trigger: 'blur'}
          ],
          newPassword: [
            {required: true, validator: validatePass2, trigger: 'blur'},
            // { pattern:/^(?=.*\d)(?=.*[a-zA-Z]).+$/, message: '必须包含字母和数字', trigger: 'blur' },
            {min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur'}
          ],
          checkNewPassword: [
            {required: true, validator: checvalidatePass2, trigger: 'blur'}
          ]
        },
        customerUserId: this.$store.getters.userId,
        warning: false,
        dialogTableVisible: false,
        buttonLoading: false,
        tableData: [], /*条件分页数据*/
        data: [], /*在下次查询后不变,实时数据除外*/
        currentData: [], /*当前数据*/
        warningNum: '', /*报警条数*/
        currentPage: 1,
        pageSize: 20,
        pageTotal: 0,
        warningTypeId: null,
        warningStatus: null,
        channelFilter: [],
        typeFilter: [{'text': '报警中', 'value': '0'}, {'text': '报警结束', 'value': '1'}],
        orderType: 'descending',
        warningMenu: '',
        warningRecordSubscribe: {},
        configRecordSubscribe: {},
        isReset: false,
        configed: false,
        configNum: 0,
        configCurrentPage: 1,
        configPageSize: 20,
        configPageTotal: 0,
        configData: [],
        configDialogVisible: false,
        versions: ['1'],
        results: [],
        configLoading: false,
        reSendData: [],
        chargingPrices: [],
        settingTypes: []
      }
    },
    components: {
      NavItem,
      Flex
    },
    computed: {
      ...mapGetters([
        'addRouters',
        'name',
        'userId',
        'customerId',
        'getCode',
        'userType',
        'showWarning'
      ]),
    },
    destroyed(){
      // 清除订阅记录
      if (this.warningRecordSubscribe && this.warningRecordSubscribe.connected) {
        this.warningRecordSubscribe.disconnect()
      }
      if (this.configRecordSubscribe && this.configRecordSubscribe.connected) {
        this.configRecordSubscribe.disconnect()
      }

    },
    mounted() {
      this.warningMenu = this.showWarning
      if(1 == this.userType){
        document.oncontextmenu = function(){  // 禁用鼠标右键
          return false
        }
      }
      if (this.warningMenu){
        this.fetchWarningType()
        this.connect()
        this.fetchWarningCount()
      }
      this.fetchCustomerById()
      this.fetchChargingPrice()

    },
    methods: {
      fetchChargingPrice: function () {//查询计费价格信息
        const condition = {customerId: this.customerId}
        this.$store.dispatch('getChargePrice',condition).then(res => {
          if(res.code === 200){
            this.chargingPrices =  res.infoJson
          }
        })
      },
      selectOne: function(selection, row){
        this.reSendData = []
        if(selection.length > 0){
          this.reSendData = selection
        }
      },
      selectAll: function(selection){
        this.reSendData = []
        if(selection.length > 0){
          this.reSendData = selection
        }
      },
      checkSelectable: function(row,index){
        return !row.flag
      },
      reSendCmd: function(){

        if(this.reSendData.length > 0){
          this.$store.dispatch('reSendCmd',this.reSendData).then(res =>{
            if(res.code == 200){
              Message({
                message: '命令下发中',
                type: 'success',
                duration: 5 * 1000
              })
            }else{
              Message({
                message: '命令下发失败',
                type: 'error',
                duration: 5 * 1000
              })
            }
            this.reSendData = []
            this.$refs.configTable.clearSelection();
          }).catch(error => {
          })
        }else{
          Message({
            message: '请勾选配置失败的记录',
            type: 'warning',
            duration: 5 * 1000
          })
        }
      },
      configClose: function(){
        this.configData = []
        this.$refs.configTable.clearFilter()
        //this.configed = false
        //this.configNum = 0
        this.configCurrentPage = 1
        this.configPageTotal = 0
        if(this.versions.length == 0){
          this.versions = ['1']
        }
      },
      getConfigRecord: function(){
        const page = {
          size: this.configPageSize,
          current: this.configCurrentPage,
          total: 0
        }
        const condition = {versions: this.versions, customerId: this.customerId, results: this.results, settingTypes: this.settingTypes}
        const data = {page: page, condition: condition}
        //selectConfigRecord(data).then(res =>{
        this.$store.dispatch('selectConfigRecord',data).then(res =>{
          this.configLoading = false
          if(res.code == 200){
            this.configData = res.infoJson.records
            this.configPageTotal = res.infoJson.total
            this.configed = false
            this.configNum = 0
          }else{
            Message({
              message: '查询批量配置记录失败',
              type: 'error',
              duration: 5 * 1000
            })
          }
        }).catch(error => {
        })
      },
      onclose: function(){
        this.warning = false
        this.$refs.warningTable.clearFilter();//重置筛选
        this.currentPage = 1
        this.warningTypeId = null
        this.warningStatus = null
      },
      configTableClassName: function(row){
        if (row.row.flag){
          return "success"
        }else{
          return "error"
        }
      },
      tableRowClassName: function(row){
        if (row.row.warningStatus === 0){
          return "warnning"
        }else if(row.row.warningStatus === 1){
          return "normal"
        }else if(row.row.warningStatus === 2){
          return "resetting"
        }else{
          return "nothing"
        }
      },
      sortChange(row) {
        this.orderType = row.order
        this.selectWarningRecord()
      },
      allConfirm() {
        let data = Object.assign([], this.tableData)
        data.forEach(d => {
          d.operator = this.customerInfo.name
        })
        this.$store.dispatch('confirmWarningRecord', data).then(response => {
          if (response.code === 200 && response.infoJson === true){
            this.$message({
              type: 'success',
              message: '确认成功',
              duration: 5 * 1000
            })
            this.warningNum -= data.length
            this.currentPage = this.currentPage - 1
          }
          this.selectWarningRecord()
          this.buttonLoading = false
        }).catch(error => {
          console.log(error)
          this.buttonLoading = false
        })
      },
      seeMore() {
        this.configData = []
        this.versions = []
        //this.configed = false
        //this.configNum = 0
        this.configCurrentPage = 1
        this.configLoading = true
        this.getConfigRecord()
      },
      redirect() {
        this.dialogTableVisible = false
        this.$router.push({ //跳转报警管理
          path: '/alarmRecord'
        })
      },
      configHandleFilterChange(filters) { // 表格筛选
        if (typeof filters.result !== 'undefined' && filters.result.length === 0) {/*判断有误*/
          this.results = []
        }
        // 报警类型筛选
        if (typeof filters.result !== 'undefined' && filters.result.length !== 0) {
          this.results = filters.result
        }
        if (typeof filters.settingType !== 'undefined' && filters.settingType.length === 0) {/*判断有误*/
          this.settingTypes = []
        }
        // 报警类型筛选
        if (typeof filters.settingType !== 'undefined' && filters.settingType.length !== 0) {
          this.settingTypes = filters.settingType
        }

        this.configLoading = true
        this.configCurrentPage = 1
        this.getConfigRecord()
      },
      handleFilterChange(filters) { // 表格筛选
        if (filters.channel !== undefined && filters.channel.length + '' === '0') {/*判断有误*/
          this.warningTypeId = []
        }
        if (filters.type !== undefined && filters.type.length + '' === '0') {
          this.warningStatus = []
        }
        // 报警类型筛选
        if (filters.channel !== undefined && filters.channel.length !== 0) {
          this.warningTypeId = filters.channel
        }
        // 报警状态筛选
        if (filters.type !== undefined && filters.type.length !== 0) {
          this.warningStatus = filters.type
        }
        // 查询表格数据
        this.selectWarningRecord()
      },
      fetchWarningCount(){
        this.$store.dispatch('getUntreatedWarningCount',this.customerId).then(res =>{
          if(res.code == 200){
            this.warningNum = res.infoJson
          }
        })
      },
      selectWarningRecord() {
        this.buttonLoading = true
        const page = {
          size: this.pageSize,
          current: this.currentPage,
          total: 0
        }
        const condition = {operator: this.orderType, warningStatues: this.warningStatus, warningTypeIds: this.warningTypeId, customerId: this.customerId}
        const data = {page: page, condition: condition}
        this.$store.dispatch('getUntreatedWarningRecordByPage',data).then(res =>{
          if(res.code == 200){
            this.tableData = res.infoJson.records
            this.pageTotal = res.infoJson.total
            if(this.isReset){
              this.warningNum = res.infoJson.total
              this.isReset = false
            }
          }else{
            Message({
              message: '查询未处理报警记录失败',
              type: 'error',
              duration: 5 * 1000
            })
          }
          this.buttonLoading = false
        }).catch(error => {
          this.buttonLoading = true
        })
      },
      fetchWarningType(){
        this.$store.dispatch('selectWarningRecordType',this.customerId).then(response => {
          if (response.code === 200) {
            this.channelFilter = []
            const result = response.infoJson
            for (const i in result) {
              this.channelFilter.push({'text': result[i].name, 'value': result[i].id})
            }
            this.mapping = result
          }
        })
      },
      rowClick(row){//表格单行处理报警处理状态方法
        this.buttonLoading = true
        let data = []
        let obj = Object.assign({}, row)
        obj.operator = this.customerInfo.name
        data.push(obj)
        this.$store.dispatch('confirmWarningRecord', data).then(response => {
          if (response.code === 200 && response.infoJson === true){
            this.$message({
              type: 'success',
              message: '确认成功',
              duration: 5 * 1000
            })
            this.warningNum -= 1
            if(this.pageTotal % this.pageSize == 1) this.currentPage = this.currentPage - 1
          }
          this.selectWarningRecord()
          this.buttonLoading = false
        }).catch(error => {
          console.log(error)
          this.buttonLoading = false
        })
      },
      handleCurrentChange: function (currentPage) {
        this.currentPage = currentPage
        this.selectWarningRecord()
      },
      configHandleSizeChange(size) { /* 改变条数*/
        this.configPageSize = size
        this.configCurrentPage = 1
        this.configData = []
        this.configLoading = true
        this.getConfigRecord()
      },
      configHandleCurrentChange: function(currentPage){
        this.configCurrentPage = currentPage
        this.configLoading = true
        this.getConfigRecord()
      },
      tableTimeFormat(row, column, cellValue) { // 表格中时间格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return moment(cellValue).format('YYYY-MM-DD HH:mm:ss')
        }
        return '--'
      },
      warningTypeFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          for (const i in this.mapping) {
            if (this.mapping[i].id === cellValue)
            {
              if (this.mapping[i].name === '充值失败')
                return <font style="color: red">充值失败</font>
            else return this.mapping[i].name

            }

          }
        }
        return '--'
      },
      tableDataFormat: function(row, column, cellValue){
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          if(cellValue.length > 30){//id
            for (const i in this.chargingPrices) {
              if(cellValue === this.chargingPrices[i].id){
                return this.chargingPrices[i].name
              }
            }
          }else if(typeof JSON.parse(cellValue) === 'boolean'){
            if(cellValue == 'true'){
              return '否'
            }else{
              return '是'
            }
          }else{
            return cellValue
          }
        }
        return '--'
      },
      tableStringFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return cellValue
        }
        return '--'
      },
      configTableStatusFormat(row, column, cellValue) { // 表格中字符串格式化
        if (row !== null && row !== undefined) {
          if (row.flag) return <font style="color: #00A5B2">成功</font>
          if (!row.flag) return <font style="color: #E57171">失败</font>
        }
        return '--'
      },
      tableStatusFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          if (cellValue === 1) return <font style="color: #00A5B2">报警结束</font>
        else if (cellValue === 0) return <font style="color: #E57171">报警中</font>
          //else if (cellValue === 2) return <font style="color: #EABB49">恢复中</font>
        }
        return '--'
      },
      configOpen: function(){
        if(this.configed){
          this.getConfigRecord()
          //this.versions = []
        }
        if (this.configed) {
          this.configLoading = true
        }
        this.configDialogVisible = true
      },
      open() {
        this.warning = false
        this.isReset = true
        this.selectWarningRecord()
        this.dialogTableVisible = true
      },
      connect() {
        //WebSocket
        this.warningRecordSubscribe = new WS();
        this.warningRecordSubscribe.connect(res => {
          this.warningRecordSubscribe.subscribe("/topic/warningRecord/"+this.customerUserId, (val) => {//读取仪表参数订阅，若接收到内容，因报停调用的读取仪表参数内容更新信息
            this.warning = true
            const warnning = JSON.parse(val.body).data
            this.warningNum += 1
            this.pageTotal += 1
            if(this.currentPage == 1){
              this.tableData.pop()
              this.tableData.unshift(warnning)
            }
          })
        }, err => {

        })

        this.configRecordSubscribe = new WS()
        this.configRecordSubscribe.connect(res => {
          this.configRecordSubscribe.subscribe("/topic/configRecord/"+this.customerUserId, (val) => {
            this.configed = true
            this.configNum += 1
            const version = JSON.parse(val.body).data
            if(this.versions.indexOf('1') > -1){
              this.versions.shift()
            }
            this.versions.push(version)
          })
        })

      },
      logout() {
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      },
      updateCustomer: function () {
        this.userInfoVisible = true;
      },
      updateCustomerPwd: function () {
        this.pwdVisible = true
      },
      saveCustomerPwd: function () {
        this.$refs.updatePwd.validate((valid) => {
          if (valid) {
            this.customerInfo.password = this.updatePwd.checkNewPassword
            this.$store.dispatch('UpdateCustomerUser', this.customerInfo).then(res => {
              if (res.code === 200) {
                Message({
                  message: '修改密码成功',
                  type: 'warning',
                  duration: 5 * 1000
                })
                this.customerInfo.password=null;
                this.pwdVisible = false
              } else {
                Message({
                  message: '修改密码失敗',
                  type: 'warning',
                  duration: 5 * 1000
                })
              }
            }).catch(error => {
            })
          } else {
            return false;
          }
        })
      },
      //保存修改信息
      saveCustomerInfo: function () {
        this.$refs.customerInfo.validate((valid) => {
          if (valid) {
            this.$store.dispatch('UpdateCustomerUser', this.customerInfo).then(res => {
              if (res.code === 200) {
                Message({
                  message: '修改信息成功',
                  type: 'warning',
                  duration: 5 * 1000
                })
                this.fetchCustomerById()
                this.userInfoVisible = false
              } else {
                Message({
                  message: '修改信息失敗',
                  type: 'warning',
                  duration: 5 * 1000
                })
              }
            }).catch(error => {
            })
          } else {
            return false;
          }
        })
      },
      closeForm(customerInfo) {
        this.userInfoVisible = false;
        this.$refs[customerInfo].clearValidate();
        this.fetchCustomerById()
      },
      closeForm2(updatePwd) {
        this.pwdVisible = false;
        this.check = false;
        this.$refs[updatePwd].resetFields();
      },
      fetchCustomerById: function () {
        this.$store.dispatch('QueryCustomerById', this.userId).then(res => {
          if (res.code === 200) {
            this.customerInfo = res.infoJson
          }
        }).catch(error => {
        })
      },
    },


  }
</script>

<style scoped rel="stylesheet/scss" lang="scss">
    .icon:hover {
        color: #00A5B2;;
    }

    .nav-bar-box {
        padding-left: 8%;
        padding-right: 8%;
        height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .nav-bar-menu {
            display: flex;
            align-items: center;
        }
        .user-show-box {
            display: flex;
        }
        .but {
            //消除button的默认样式
            margin: 0;
            padding: 0;
            border: 1px solid transparent; //自定义边框
            outline: none; //消除默认点击蓝色边框效果
            background-color: transparent;
        }

    }
    td {
        padding: 5px;
    }

</style>
<style>
    .updateUser  .el-dialog__body{
        padding: 0rem 0rem;
        border-top: 1px solid #dedede;
        border-bottom: 1px solid #dedede;
    }
    .updateUser .el-dialog {
        background: rgb(247, 247, 247);
    }
    .nav-bar-box .updateUser  button{
        font-weight: bold
    }
    .el-table .warnning {
        background: #FFFAFA;
    }

    .el-table .normal {
        background: #F7FEFF;
    }

    .el-table .resetting {
        background: #FEFDF9;
    }

    .el-table .nothing {
        background: white;
    }

    .el-table .success {
        background: #F7FEFF;
    }

    .el-table .error {
        background: #FFFAFA;
    }
</style>

